import { defineMessages } from 'react-intl';

const messages = defineMessages({
  hotkeys: {
    description: 'hotkeys modal title',
    defaultMessage: 'Hotkeys',
    id: 'qVrdUZ',
  },
  basicHotkeys: {
    description: 'basic hotkeys title',
    defaultMessage: 'Basic Hotkeys',
    id: '8uxAed',
  },
  advancedHotkeys: {
    description: 'hotkeys modal advanced hotkeys title',
    defaultMessage: 'Advanced Hotkeys',
    id: '9JeRJL',
  },
  advancedHotkeysEnabled: {
    description: 'hotkeys modal enable advanced hotkeys enabled',
    defaultMessage: 'Advanced Hotkeys Enabled',
    id: 'CqHjFC',
  },
  cancel: {
    description: 'hotkeys modal cancel button',
    defaultMessage: 'Cancel',
    id: 'T2AwzK',
  },
  printPdf: {
    description: 'hotkeys modal print pdf button',
    defaultMessage: 'Print PDF',
    id: 'zTIf4U',
  },
  saveChanges: {
    description: 'hotkeys modal save changes button',
    defaultMessage: 'Save Changes',
    id: '9h7OD2',
  },
  general: {
    description: 'hotkeys modal general subtitle',
    defaultMessage: 'General',
    id: 'hK3sTc',
  },
  escape: {
    description: 'general hotkeys escape',
    defaultMessage: 'Esc',
    id: '+lI+rB',
  },
  shiftClick: {
    description: 'general hotkeys shift click',
    defaultMessage: 'Shift + Click',
    id: 'wMlDjS',
  },
  selectMultipleRows: {
    description: 'general hotkeys select multiple rows',
    defaultMessage: 'Select multiple rows',
    id: 'fyh7N9',
  },
  ctrlOrCmdClick: {
    description: 'general hotkeys ctrl or cmd click',
    defaultMessage: '{ctrlOrCmd} + Click',
    id: 'gCsO1M',
  },
  toggleRowSelection: {
    description: 'general hotkeys toggle row selection',
    defaultMessage: 'Toggle row selection',
    id: 'ZOOuib',
  },
  moveToNextRow: {
    description: 'general hotkeys move to next row',
    defaultMessage: 'Move to the next row',
    id: 'RXyyDT',
  },
  moveToPreviousRow: {
    description: 'general hotkeys move to previous row',
    defaultMessage: 'Move to the previous row',
    id: '5MTt8Q',
  },
  customShippingPresets: {
    description: 'hotkeys custom shipping presets subtitle',
    defaultMessage: 'Custom Shipping Presets',
    id: 'GBv0QM',
  },
  shippingOrders: {
    description: 'hotkeys shipping orders subtitle',
    defaultMessage: 'Shipping Orders',
    id: 'sgz0y3',
  },
  updateStores: {
    description: 'hotkeys update all stores',
    defaultMessage: 'Update all stores',
    id: '3MAWe9',
  },
  showRateCalc: {
    description: 'hotkeys show rate calculator',
    defaultMessage: 'Show Rate Calculator',
    id: 'dbVZLz',
  },
  navigation: {
    description: 'hotkeys modal navigation subtitle',
    defaultMessage: 'Navigation',
    id: 'bpYbwd',
  },
  printingDocuments: {
    description: 'hotkeys modal printing documents subtitle',
    defaultMessage: 'Printing Documents',
    id: 'DpLX8+',
  },
  openScanToSearch: {
    description: 'hotkey modal open scan to search subtitle',
    defaultMessage: 'Enable Barcode Listening screen to view, batch, or ship scanned orders.',
    id: 'prA9KN',
  },
  ctrlOrCmdShiftS: {
    description: 'hotkey modal open scan to search hotkey',
    defaultMessage: '{ctrlOrCmd} + Shift + s',
    id: '1F9/TS',
  },
});

export default messages;
